/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';

/**
 * The SCV export type.
 * @export
 */
export type EntityScvExport = io.TypeOf<typeof ScvExport>;

/**
 * The SCV export entity definition.
 * @export
 */
export const ScvExport = io.intersection(
  [
    io.type({
      exportid: io.string,
    }),
    io.partial({
      signedURL: io.string,
    }),
  ],
  `ScvExport`,
);
